var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.733,
    height: 19.733,
    viewBox: "0 0 19.733 19.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Search_Icon",
    "data-name": "Search Icon",
    d: "M15.663,13.85A8.358,8.358,0,0,0,17.39,8.7,8.658,8.658,0,0,0,8.757,0,8.763,8.763,0,0,0,0,8.7a8.763,8.763,0,0,0,8.757,8.7,8.222,8.222,0,0,0,5.18-1.716l3.7,3.677a1.2,1.2,0,0,0,1.727,0,1.18,1.18,0,0,0,0-1.716Zm-6.907.981A6.193,6.193,0,0,1,2.467,8.7a6.29,6.29,0,0,1,12.58,0A6.193,6.193,0,0,1,8.757,14.831Z",
    fill: "#bcbccb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/Search Icon.5faea373715cbd996f59ecb6dbfc1cd9.svg";
export { ForwardRef as ReactComponent };